var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9393398,16.9393398 C27.5251263,16.3535534 28.4748737,16.3535534 29.0606602,16.9393398 C29.6464466,17.5251263 29.6464466,18.4748737 29.0606602,19.0606602 L23.121,25 L29.0606602,30.9393398 C29.609835,31.4885146 29.6441584,32.357577 29.1636304,32.9467378 L29.0606602,33.0606602 C28.4748737,33.6464466 27.5251263,33.6464466 26.9393398,33.0606602 L19.9393398,26.0606602 C19.3535534,25.4748737 19.3535534,24.5251263 19.9393398,23.9393398 L26.9393398,16.9393398 Z",
    id: "Path-3",
    fill: "#1C1D1D",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.36ee95c47dcd0b65d62e841211c8742b.svg";
export { ForwardRef as ReactComponent };